// extracted by mini-css-extract-plugin
module.exports = {"root":"autocomplete-root_root__sQKg2"};